import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesDeliveryFees } from "../../constants";
import { CreateDeliveryLocationBody } from "./createDeliveryLocation.types";

export const requestCreateDeliveryLocation = async (
  body: CreateDeliveryLocationBody
): Promise<void> => {
  const getUrl = () => {
    if (!body.cityName) {
      return buildUrl(ApiRoutesDeliveryFees.DeliveryLocationCountry);
    }

    if (!body.areaName) {
      return buildUrl(ApiRoutesDeliveryFees.DeliveryLocationCity);
    }

    return buildUrl(ApiRoutesDeliveryFees.DeliveryLocationArea);
  };

  return await instance.post(getUrl(), body);
};
